import { Model } from '@/clients/http'

import { CouponHttpParams, CouponResponses } from '@/types'

export class CouponModel extends Model {
  // Define correlation keys for Redux state management
  public static readonly correlations = {
    GET_LIST: 'GET_COUPON_LIST',
    GET_BY_ID: 'GET_COUPON_BY_ID',
    CREATE: 'CREATE_COUPON',
    UPDATE: 'UPDATE_COUPON',
    DELETE: 'DELETE_COUPON',
  }

  // Define endpoint builders
  public static readonly endpoints = {
    getList: (props?: CouponHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/coupon',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: CouponHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/coupon/:id',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: CouponHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/coupon',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: CouponHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/coupon/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: CouponHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/coupon/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  /**
   * Get paginated list of coupons
   */
  public static readonly getList = async (props?: CouponHttpParams.GetList) => {
    return this.createHttpRequest<CouponResponses.GetList, CouponResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /**
   * Get a single coupon by ID
   */
  public static readonly getById = async (props: CouponHttpParams.GetById) => {
    return this.createHttpRequest<CouponResponses.GetById, CouponResponses.GetByIdError>({
      correlationKey: this.correlations.GET_BY_ID,
      payload: {
        method: 'get',
        url: this.endpoints.getById(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /**
   * Create a new coupon
   */
  public static readonly create = async (props: CouponHttpParams.Create) => {
    return this.createHttpRequest<CouponResponses.Create, CouponResponses.CreateError>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /**
   * Update an existing coupon
   */
  public static readonly update = async (props: CouponHttpParams.Update) => {
    return this.createHttpRequest<CouponResponses.Update, CouponResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /**
   * Delete a coupon
   */
  public static readonly delete = async (props: CouponHttpParams.Delete) => {
    return this.createHttpRequest<CouponResponses.Delete, CouponResponses.DeleteError>({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
